import React from "react";
import {Switch} from "@material-ui/core";
import {Input} from "@components/Input";

const DEFAULT_REUSE_WINDOW_HOURS = 24;

export const isValidTicketReuseWindow = (enabled, value) => {
    if (!enabled) return true;

    const hours = Number(value);
    return Number.isInteger(hours) && hours >= 1 && hours <= 24;
};

export const normalizeTicketReuseWindow = (enabled, value) => (
    enabled ? Number(value) : 0
);

export const toggleTicketReuse = (enabled) => (
    enabled ? 0 : DEFAULT_REUSE_WINDOW_HOURS
);

const TicketReuseSettings = ({t, enabled, value, closeMessage, onToggle, onChange, onCloseMessageChange}) => {
    const valid = isValidTicketReuseWindow(enabled, value);

    return (
        <React.Fragment>
            <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                    <span className={"elements_custom__title"}>
                        {t("integrations:channels.centridesk.ticket_reuse.enabled.title")}
                    </span>
                    <span className={"elements_custom__description"}>
                        {t("integrations:channels.centridesk.ticket_reuse.enabled.description")}
                    </span>
                </div>
                <Switch
                    checked={enabled}
                    onChange={onToggle}
                    inputProps={{"aria-label": t("integrations:channels.centridesk.ticket_reuse.enabled.title")}}
                />
            </div>
            {enabled && (
                <React.Fragment>
                    <div className={"elements_custom"}>
                        <div className={"elements_custom__info"}>
                            <span className={"elements_custom__title"}>
                                {t("integrations:channels.centridesk.ticket_reuse.window.title")}
                            </span>
                            <span className={"elements_custom__description"}>
                                {t("integrations:channels.centridesk.ticket_reuse.window.description")}
                            </span>
                        </div>
                        <Input
                            inputType={"number"}
                            inputProps={{min: 1, max: 24, step: 1}}
                            value={value}
                            error={!valid}
                            helper={!valid ? t("integrations:channels.centridesk.ticket_reuse.window.error") : t("integrations:channels.centridesk.ticket_reuse.window.helper")}
                            onChange={onChange}
                        />
                    </div>
                    <div className={"elements_custom"}>
                        <div className={"elements_custom__info"}>
                            <span className={"elements_custom__title"}>
                                {t("integrations:channels.centridesk.ticket_reuse.close_message.title")}
                            </span>
                            <span className={"elements_custom__description"}>
                                {t("integrations:channels.centridesk.ticket_reuse.close_message.description")}
                            </span>
                        </div>
                        <Input
                            value={closeMessage}
                            type={"primary"}
                            multiline
                            inputProps={{maxLength: 2000}}
                            placeholder={t("integrations:channels.centridesk.ticket_reuse.close_message.placeholder")}
                            helper={t(
                                "integrations:channels.centridesk.ticket_reuse.close_message.helper",
                                {hours: "{{hours}}"}
                            )}
                            onChange={onCloseMessageChange}
                        />
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default TicketReuseSettings;
